import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-message-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.06992 20C9.9785 20.9791 12.174 21.2443 14.2608 20.7478C16.3476 20.2514 18.1885 19.0259 19.4517 17.2922C20.7149 15.5586 21.3173 13.4308 21.1505 11.2922C20.9837 9.15366 20.0585 7.14502 18.5417 5.62824C17.025 4.11146 15.0163 3.1863 12.8778 3.01946C10.7392 2.85263 8.61139 3.45509 6.87774 4.71829C5.14409 5.98149 3.91861 7.82236 3.42214 9.90916C2.92568 11.996 3.19086 14.1915 4.16992 16.1L2.16992 22L8.06992 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`
})
export class MessageIconComponent {

}
